module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAAEAQMAAAB1Fsd5AAAAA1BMVEUzMzPK7GI1AAAAAXRSTlOArV5bRgAAAApJREFUCB1jgAIAAAgAAYw3ty8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./ngapp/images/goal-header-bg.png
// module id = 587
// module chunks = 0